import { reduce } from 'bluebird';

async function runMiddleware(reduced, middleware) {
  console.info('Running middleware', { reduced, middleware });
  const newReduced = {...reduced};
  if (!reduced.redirect || middleware.alwaysRun) {
    let result = await middleware(reduced.nextState);
    result = result || {};

    if (result.redirect) {
      newReduced.redirect = result.redirect;
    }
  } else {
    console.info('Another route middleware is requesting a redirect.  Skipping', middleware);
  }

  return newReduced;
}

function applyMiddleware(...middlewares) {

  return function(nextState, replace, done) {
    const thisObj = this || {};
    console.info('Running all middleware', { thisObj, nextState, middlewares });
    return reduce(middlewares, runMiddleware, { nextState }).then(result => {
      if (result.redirect) {
        replace(result.redirect);
      }
      console.info('Done running middleware', { thisObj, middlewares, nextState });
      done();
      return null;
    }).catch(err => {
      console.info('Error running middleware', { thisObj, middlewares, nextState }, err);
      done(err);
      return null;
    });
  };
}

export default applyMiddleware;



// WEBPACK FOOTER //
// ./src/utils/route/applyMiddleware.js